<template>
    <div :contenteditable="!readonly" @input="update" @blur="deformat(); $emit('blur')"></div>
</template>

<script>
    export default {
        data: function(){
            return {
                timer: undefined
            }
        },
        props: [
            'content',
            'readonly'
        ],
        mounted: function () {
            this.$el.innerText = this.content;
        },
        methods: {
            deformat: function(){
                this.$el.innerText = this.content;
            },
            update: function (event) {
                this.$emit('update', event.target.innerText);
            }
        },
    } 
</script>